import React, { Component } from "react";
import debounce from "lodash/debounce";
import escapeRegExp from "lodash/escapeRegExp";

import Input from "@stadium/ui/src/components/input/input";

class SearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = { query: "" };

    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.filterData = debounce(this.filterData.bind(this), 300, {
      leading: false,
      trailing: true,
    });
    this.inputRef = null;
  }

  componentDidUpdate({ reset: prevReset, focus: prevFocus }) {
    const { reset, focus } = this.props;
    if (reset && !prevReset) {
      this.setState({ query: "" });
    }

    if (focus && !prevFocus) {
      this.inputRef.focus();
    }
  }

  handleQueryChange({ value }) {
    this.setState({ query: value }, this.filterData());
  }

  filterData() {
    // data = array of objects
    const { data = [], attributes, onFilter } = this.props;
    const { query } = this.state;

    const filteredData = data.filter((obj) => {
      const regexp = new RegExp(escapeRegExp(query.trim()), "i");
      return attributes.some((attr) => regexp.test(obj[attr]));
    });

    onFilter(filteredData);
  }

  render() {
    const { id, name, placeholder = "" } = this.props;
    const { query } = this.state;

    return (
      <Input
        id={id}
        name={name}
        value={query}
        onChange={this.handleQueryChange}
        inputClass=""
        customClass="form-control-padding form-control"
        placeholder={placeholder}
        autoComplete="off"
        refs={(ref) => (this.inputRef = ref)}
      />
    );
  }
}

export default SearchInput;
